import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export function SortableItem(props: { id: string | number; children: React.ReactNode; onWrapperClick?: () => void }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: props.id });

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (isDragging || event.defaultPrevented) return;

    if (props.onWrapperClick) {
      props.onWrapperClick();
      return;
    }

    const wrapper = event.currentTarget as HTMLElement;
    const commandItem = wrapper.querySelector('[data-slot="command-item"]') as HTMLElement | null;

    if (!commandItem) return;

    commandItem.click();
  };

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      onClick={handleClick}
      {...attributes}
      {...listeners}
    >
      {props.children}
    </div>
  );
}
